import { Navigate, useParams } from 'react-router-dom';
import { useAtomValue } from 'jotai';
import Markdown from 'markdown-to-jsx';

import { ContentWrapper, Description, Image } from './index.styles';

import PageWrapper from '../../../../../../page_wrapper';
import HeaderWithButton from '../../../../header_with_button';

import { vendorCardOfferQuery } from '../../../../../../../store';

import type { Offer } from '@rewardopl/types';

export default function OfferPage() {
  const { offer_id: offerId } = useParams<{ offer_id?: Offer['_id'] }>();

  if (!offerId) {
    throw new Error('offerId is undefined');
  }

  const offer = useAtomValue(vendorCardOfferQuery(offerId));

  if (!offer) {
    return <Navigate to=".." />;
  }

  const { description, name, picture } = offer;

  return (
    <>
      <HeaderWithButton>{name}</HeaderWithButton>
      <PageWrapper withPadding={false}>
        {picture ? <Image src={`/api/uploads/${picture}`} alt={name} /> : null}
        <ContentWrapper>
          {description ? (
            <Description>
              <Markdown>{description}</Markdown>
            </Description>
          ) : null}
        </ContentWrapper>
      </PageWrapper>
    </>
  );
}
